<ion-app [class]="appClass()">
  <ng-content></ng-content>
</ion-app>
